import React from 'react'

import { Card, RadioButton, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { WizardData } from 'modules/procurement/components/purchaseOrders/UpdateOrderModal/types'

interface Props {
  selected?: boolean
}

const IWillDecideLater: React.FC<
  Pick<WizardStepRenderParams<WizardData>, 'data' | 'onDataChanged'> & Props
> = ({ selected, data, onDataChanged }) => {
  const handleSelected = () => {
    onDataChanged({
      ...data,
      preferredPaymentMethod: undefined,
    })
  }

  return (
    <Card onClick={handleSelected}>
      <Card.Title
        action={
          <RadioButton
            value="later"
            checked={!!selected}
            onChange={(event) => event.target.value === 'later' && handleSelected()}
          />
        }
      >
        {i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.payment_method.options.i_will_decide_later.title'
        )}
      </Card.Title>
    </Card>
  )
}

export default IWillDecideLater
